
<img draggable="false" [src]="src || defaultSrc" class="block-logo" [class.editable]="editable" (click)="editable ? openDialog() : null">